import { type RouteObject } from 'react-router'

/**
 * Creates routes for the account management feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '/docs',
      lazy: {
        Component: () =>
          import('@/features/docs/DocumentsView/DocumentsViewContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
